export const projEn = {
  menuRoles: 'Users and roles',
  more: 'More projects:',
  archivedProjects: 'Archived projets',
  showArchived: 'Show',
  hideArchived: 'Hide',
  adminProjects: 'Projects for administration',
  adminProjectsHelp:
    'You are not added to these projects as participant but you can see and edit them as a company administrator',
  usersTab: 'Users in project',
  rolesTab: 'Roles in project',
  addRole: 'Add role',
  copyRole: 'Copy from other project',
  newRole: 'New role in project',
  editRole: 'Change role in project',
  roleName: 'Role name',
  roleNamePl: 'Enter role name',
  roleDescr: 'Role description',
  roleDescrPl: 'Enter role description',
  rolePermissions: 'Role permissions',
  roleNameEmpty: 'Enter role name',
  roleNoDescr: 'No description',
  systemRole: 'system role',
  groupDeprecationHint:
    'Please, add role in your project insdead. Groups will be migrated ' +
    'to project roles soon',
  colName: 'Name',
  colPosition: 'Position',
  colDep: 'Department',
  colRole: 'Role in project',
  searchPl: 'Search name, position, department',
  saveRole: 'Save role',
  cancel: 'Cancel',
  unsavedChangesHint: 'You have unsaved changes. Go back and without saving?',
  emailInvite: 'Invite to project by e-mail',
  createNewRole: 'Create new role',
  unsavedWarn: 'There are unsaved changes',
  saveChanges: 'Save changes',
  or: 'or',
  exitNoSave: 'exit without saving',
  deleteRole: 'Delete role',
  deleteRoleWarn1: 'Delete this role in project?',
  noCustomRoles: 'No custom roles in this project',
  roles: 'Roles in project',
  showMore: (count: number) => `Show more (${count})`,
  statusEdited: 'Edited',
  statusDefault: (type: 'project' | 'board' | 'column' | 'task'): string => {
    switch (type) {
      case 'project':
        return 'Default'
      case 'board':
        return 'As in project'
      case 'column':
        return 'As in board'
      case 'task':
        return 'As in column'
    }
  },
  editIdProjectPopupTitle: 'Change project task ID prefix',
  projectsIdTitle: 'Project ID Prefix',
  idTask: 'Task ID'
}

export const projRu: typeof projEn = {
  menuRoles: 'Участники и роли',
  more: 'Ещё проектов:',
  archivedProjects: 'Архивированные проекты',
  showArchived: 'Показать',
  hideArchived: 'Скрыть',
  adminProjects: 'Проекты для администрирования',
  adminProjectsHelp:
    'Вы не добавлены в эти проекты как участник, но можете видеть и редактировать эти проекты как администратор компании',
  usersTab: 'Участники проекта',
  rolesTab: 'Настройка ролей в проекте',
  addRole: 'Добавить роль',
  copyRole: 'Копировать из другого проекта ',
  newRole: 'Новая роль в проекте',
  editRole: 'Изменить роль в проекте',
  roleName: 'Название роли',
  roleNamePl: 'Введите название роли',
  roleDescr: 'Описание роли',
  roleDescrPl: 'Введите описание роли',
  rolePermissions: 'Права для роли',
  roleNameEmpty: 'Необходимо ввести название роли',
  roleNoDescr: 'Без описания',
  systemRole: 'встроенная роль',
  groupDeprecationHint:
    'Добавьте роль в проект вместо группы прав. Функционал групп прав ' +
    'перенесён в роли и существующие группы прав будут скоро перенесены в роли',
  colName: 'Имя',
  colPosition: 'Должность',
  colDep: 'Отдел',
  colRole: 'Роль в проекте',
  searchPl: 'Поиск по имени, должности, отделу',
  saveRole: 'Сохранить роль',
  cancel: 'Отмена',
  unsavedChangesHint:
    'У вас есть несохранённые изменения. Вернуться без сохранения?',
  emailInvite: 'Пригласить сотрудника в проект по почте',
  createNewRole: 'Создать новую роль',
  unsavedWarn: 'Есть несохранённые данные',
  saveChanges: 'Сохранить изменения',
  or: 'или',
  exitNoSave: 'выйти без сохранения',
  deleteRole: 'Удалить роль',
  deleteRoleWarn1: 'Удалить роль в проекте?',
  noCustomRoles: 'В этом проекте нет добавленных ролей',
  roles: 'Роли в проекте',
  showMore: (count: number) => `Показать ещё ${count}`,
  statusEdited: 'Изменено',
  statusDefault: (type: 'project' | 'board' | 'column' | 'task'): string => {
    switch (type) {
      case 'project':
        return 'По умолчанию'
      case 'board':
        return 'Как у проекта'
      case 'column':
        return 'Как у доски'
      case 'task':
        return 'Как у колонки'
    }
  },
  editIdProjectPopupTitle: 'Изменить префикс ID задач проекта',
  projectsIdTitle: 'ID-префикс проекта',
  idTask: 'ID задачи'
}
